import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import { StyledHeaderButton, StyledBurgerButton, TextButton } from './styles';
import RoutesUtils from '../../../../utils/routes';
import { MenuItemType } from '../../../../typings/menu';
import UserAgentUtils from '../../../../utils/userAgent';
import Tooltip from '../../../Tooltip';
import { openCustomItem, requestOpenLeftSideMenu } from '../../../../containers/MenuManager/actions';
import { getMenuButtonIcon } from '../../../../utils/menuManager';

interface HeaderButtonProps {
	icon?: string;
	label?: string;
	type?: MenuItemType;
	target?: string;
	dispatch: Dispatch<StoreState>;
	isMultiApp: boolean;
	iconSrc: string;
	isActive: boolean;
}

const HeaderButton = (props: HeaderButtonProps) => {
	const handleClick = () => {
		const { target, type, dispatch } = props;

		switch (type) {
			case MenuItemType.Link:
			case MenuItemType.Asset:
			case MenuItemType.Folder:
			case MenuItemType.Page:
				dispatch(openCustomItem(type, target as string));
				break;
			case MenuItemType.BurgerButton:
				dispatch(requestOpenLeftSideMenu());
				break;
			default:
				RoutesUtils.historyPush(target as string);
				break;
		}
	};

	const { icon, iconSrc, label, type, isMultiApp, isActive } = props;
	const tooltipId = Utils.generateId();
	const isCustom = type === MenuItemType.Link || type === MenuItemType.Asset || type === MenuItemType.Page || type === MenuItemType.Folder;
	const StyledButton = type !== MenuItemType.BurgerButton ? StyledHeaderButton : StyledBurgerButton;

	return (
		<StyledButton
			className={`StyledButton-${type}`}
			onClick={handleClick}
			data-tip={true}
			data-for={tooltipId}
			isMultiApp={isMultiApp}
			isActive={isActive}
		>
			{getMenuButtonIcon(iconSrc)}
			{!icon && label &&
				<TextButton><Translate value={label} /></TextButton>
			}
			{(UserAgentUtils.isDesktop() && label) &&
				<Tooltip id={tooltipId} text={label} isCustom={isCustom} />
			}
		</StyledButton>
	);
};

export default HeaderButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/HeaderButton/index.tsx